import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiService } from '../services/apiService';
import { DSCard } from '../design-system/primitives';
import './KnowledgeBase.css';

function KnowledgeBaseArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [categories, setCategories] = useState([]);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isActive = true;

    const fetchArticle = async () => {
      try {
        setLoading(true);
        const response = await apiService.getKnowledgeBaseArticle(slug);
        if (!isActive) {
          return;
        }
        setArticle(response.data.article);
        setCategories(response.data.categories || []);
        setRelated(response.data.related || []);
        setError(null);
      } catch (err) {
        if (!isActive) {
          return;
        }
        setError('Unable to load this article.');
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    fetchArticle();
    return () => {
      isActive = false;
    };
  }, [slug]);

  const primaryCategory = categories[0];
  const lastUpdated = article?.modified_at || article?.updated_at;

  if (loading) {
    return (
      <div className="kb-page">
        <div className="kb-content">
          <DSCard className="kb-hero" cornerVariant="lg">
            <h1>Loading article...</h1>
          </DSCard>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="kb-page">
        <div className="kb-content">
          <DSCard className="kb-hero" cornerVariant="lg">
            <h1>Help Center</h1>
            <p>{error}</p>
          </DSCard>
        </div>
      </div>
    );
  }

  return (
    <div className="kb-page">
      <div className="kb-content">
        <div className="kb-breadcrumbs">
          <Link to="/help">Help Center</Link>
          {primaryCategory && (
            <>
              <span>/</span>
              <Link to={`/help/category/${primaryCategory.slug}`}>{primaryCategory.name}</Link>
            </>
          )}
          <span>/</span>
          <span>{article?.title}</span>
        </div>

        <DSCard className="kb-article-panel" cornerVariant="lg">
          <h1>{article?.title}</h1>
          {lastUpdated && (
            <div className="kb-article-meta">
              Last updated {new Date(lastUpdated).toLocaleDateString()}
            </div>
          )}
          <div
            className="kb-article-content"
            dangerouslySetInnerHTML={{ __html: article?.content_html || '' }}
          />
        </DSCard>

        <div className="kb-related">
          <h3>Related articles</h3>
          <div className="kb-article-list">
            {related.map((item) => (
              <Link
                key={item.id}
                to={`/help/article/${item.slug}`}
                className="kb-article-item"
              >
                <h3>{item.title}</h3>
                <div
                  className="kb-excerpt"
                  dangerouslySetInnerHTML={{ __html: item.excerpt || '' }}
                />
              </Link>
            ))}
            {related.length === 0 && (
              <DSCard className="kb-empty" cornerVariant="md">No related articles yet.</DSCard>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default KnowledgeBaseArticle;
